var React = require('react');

function BeepInline (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"226","cy":"11","r":"207.5","stroke":"#0A9E50","strokeWidth":"37","key":0}),React.createElement("circle",{"cx":"236.5","cy":"2.5","r":"138","stroke":"#0A9E50","strokeWidth":"37","key":1}),React.createElement("circle",{"cx":"245","cy":"-7","r":"98","fill":"#0A9E50","key":2})]);
}

BeepInline.defaultProps = {"width":"596","height":"474","viewBox":"0 0 298 237","fill":"none"};

module.exports = BeepInline;

BeepInline.default = BeepInline;
